import { Input } from '@material-tailwind/react';
import { Search } from 'lucide-react';
import React from 'react';

const css =
  'placeholder:text-gray-500 text-gray-900 !border !border-gray-300  placeholder:opacity-100 focus:!border-blue-900 focus:!border-t-blue-900 focus:ring-gray-900/10 placeholder:opacity-100  bg-white dark:bg-darkBgInput ';

const InputSearchArvore = ({ handleSubmit }) => {
  return (
    <form onSubmit={handleSubmit} className="w-52 ml-auto mt-3">
      <Input
        type="Search"
        label="Buscar"
        className={`${css} uppercase`}
        labelProps={{
          className: 'hidden',
        }}
        placeholder="Digite a tag"
        icon={<Search />}
      ></Input>
    </form>
  );
};

export default InputSearchArvore;
